import React, { useContext } from 'react';

export type PermissionOverridesContextValue = {
  /** Bumps when localStorage permission overrides change. */
  localOverrideEpoch: number;
  notifyPermissionOverridesChanged: () => void;
};

export const PermissionOverridesContext =
  React.createContext<PermissionOverridesContextValue>({
    localOverrideEpoch: 0,
    notifyPermissionOverridesChanged: () => {},
  });

export const usePermissionOverrides = (): PermissionOverridesContextValue =>
  useContext(PermissionOverridesContext);
